import ComprehensiveIncome from '../pages/ComprehensiveIncome';

const comprehensiveIncomeRoute = {
  public: [],
  auth: [
    {
      name: 'comprehensive_income',
      path: '/finance-and-accounting/comprehensive-income',

      component: ComprehensiveIncome,
    },
  ],
};

export default comprehensiveIncomeRoute;
